import React, { PropsWithChildren } from 'react'
import Television from './television'
import styled from 'styled-components'


const Container = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 50vw;
  height: 100vh;
  min-width: 850px;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  box-sizing: border-box;
  filter: contrast(170%) brightness(90%);
  pointer-events: none;

    @media (max-width: 1940px) {
      right: 5rem;
    }
    @media (max-width: 1600px) {
      right: -5rem;
    }
    

    @media (max-width: 740px) {
      min-width: 100%;
      bottom: 0rem;
      right: 0;
    }

    @media (max-width: 390px) {
      right: 0;
    }

    @media  (max-height: 960px) {
      bottom: 0;
    }

  
`
const Hugo: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  return (
    <Container>
      <Television>
        {children}
      </Television>
    </Container>
  )
}

export default Hugo
